import React, { createContext, useContext, ReactNode } from 'react';
import { usePlaylistContext } from './PlaylistContext';
import { getstripePrices } from '../utils';

interface PricingContextType {
  // Add any methods if needed for future
}

const PricingContext = createContext<PricingContextType | undefined>(undefined);

export const usePricingContext = () => {
  const context = useContext(PricingContext);
  if (!context) {
    throw new Error('usePricingContext must be used within a PricingProvider');
  }
  return context;
};

interface PricingProviderProps {
  children: ReactNode;
}

export const PricingProvider: React.FC<PricingProviderProps> = ({ children }) => {
  const { dispatch: playlistDispatch } = usePlaylistContext();

  React.useEffect(() => {
    (async () => {
      try {
        let STRIPE_PRO_MONTHLY = process.env.REACT_APP_STRIPE_PRO_MONTHLY;
        let STRIPE_PRO = process.env.REACT_APP_STRIPE_PRO;
        let STRIPE_UNLIMITED_MONTHLY = process.env.REACT_APP_STRIPE_UNLIMITED_MONTHLY;
        let STRIPE_UNLIMITED = process.env.REACT_APP_STRIPE_UNLIMITED;
        let prices = await getstripePrices();
        let proPlans = prices.data.data.filter(
          obj => obj.id === STRIPE_PRO || obj.id === STRIPE_PRO_MONTHLY
        );
        let unlimitedPlans = prices.data.data.filter(
          obj => obj.id === STRIPE_UNLIMITED_MONTHLY || obj.id === STRIPE_UNLIMITED
        );

        let monthly_pro_price = Object.values(
          proPlans.filter(obj => obj.id === STRIPE_PRO_MONTHLY)[0].currency_options
          // @ts-ignore
        ).map(obj => obj.unit_amount);
        let annually_pro_price = Object.values(
          proPlans.filter(obj => obj.id === STRIPE_PRO)[0].currency_options
          // @ts-ignore
        ).map(obj => obj.unit_amount);
        let monthly_unlimited_price = Object.values(
          unlimitedPlans.filter(obj => obj.id === STRIPE_UNLIMITED_MONTHLY)[0].currency_options
          // @ts-ignore
        ).map(obj => obj.unit_amount);
        let annually_unlimited_price = Object.values(
          unlimitedPlans.filter(obj => obj.id === STRIPE_UNLIMITED)[0].currency_options
          // @ts-ignore
        ).map(obj => obj.unit_amount);
        playlistDispatch({
          type: 'SET_PLANS_PRICING',
          payload: {
            proPlansPrices: proPlans,
            unlimitedPlansPrices: unlimitedPlans,
            monthly_pro_price,
            annually_pro_price,
            monthly_unlimited_price,
            annually_unlimited_price,
          },
        });
      } catch (err) {
        console.error('Failed to initialize pricing:', err);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PricingContext.Provider value={{}}>
      {children}
    </PricingContext.Provider>
  );
};
